import { render, staticRenderFns } from "./notification-button.vue?vue&type=template&id=3bda3d1a&scoped=true"
import script from "./notification-button.vue?vue&type=script&lang=js"
export * from "./notification-button.vue?vue&type=script&lang=js"
import style0 from "./notification-button.vue?vue&type=style&index=0&id=3bda3d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda3d1a",
  null
  
)

export default component.exports